import { slideIn, slideOut } from "./Helpers/animations";

const leftNavContainer: HTMLDivElement | null = document.querySelector('.slide-left-nav');
const leftNavToggle: HTMLButtonElement | null = document.querySelector('.left-nav-toggle');
const leftNavMenu: HTMLDivElement | null = document.querySelector('.slide-left-nav .side-menu');

if (leftNavContainer && leftNavToggle && leftNavMenu) {
    leftNavToggle.addEventListener('click', () => {
        if (!leftNavMenu.getAnimations().some(animation => animation.playState === 'running' || animation.pending)) {
            if (leftNavMenu.style.display === 'none') {
                slideIn(leftNavMenu, 300, {
                    distance: 0,
                    callback: () => leftNavToggle.ariaExpanded = 'true'
                });
            } else {
                slideOut(leftNavMenu, 300, {
                    toggle: leftNavToggle,
                    callback: () => leftNavToggle.ariaExpanded = 'false'
                });
            }
        }
    });

    document.addEventListener('click', event => {
        if (!leftNavContainer.contains(event.target as HTMLElement) &&
            leftNavMenu.style.display !== 'none' &&
            !leftNavMenu.getAnimations().some(animation => animation.playState === 'running' || animation.pending)
        ) {
            slideOut(leftNavMenu, 300, {
                callback: () => leftNavToggle.ariaExpanded = 'false'
            });
        }
    });

    document.querySelector('.close-left-nav')?.addEventListener('click', () => {
        slideOut(leftNavMenu, 300, {
            toggle: leftNavToggle,
            callback: () => leftNavToggle.ariaExpanded = 'false'
        });
    });

    leftNavContainer.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            slideOut(leftNavMenu, 300, {
                toggle: leftNavToggle,
                callback: () => leftNavToggle.ariaExpanded = 'false'
            });
        }
    });
}